import axios from 'axios';

export const userReceivedAPI = async () => {
  const response = await axios(process.env.REACT_APP_SUBMISSION_SEARCH_API, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${window.sessionStorage.accessToken}`,
    },
  });
  return response.data;
}

export default userReceivedAPI;

export const managerTeamAPI = async () => {
  const response = await axios(process.env.REACT_APP_SUBMISSION_MANAGER_SEARCH_API, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${window.sessionStorage.accessToken}`,
    },
  });
  return response.data;
}



// WEBPACK FOOTER //
// ./src/services/userReceivedAPI.js